/**
 * Custom Menu Bar: open mega / dropdown <details> on hover and focus (desktop UX).
 * Keeps click/tap behavior for touch; closes sibling panels when switching items.
 */
(function () {
  var HOVER_CLOSE_MS = 180;
  var ROOT = '.custom-menu-bar';

  function bindDetails(details) {
    if (!details || details.dataset.menuHoverBound === 'true') return;
    details.dataset.menuHoverBound = 'true';

    var closeTimer;

    function clearClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function closeSiblings() {
      var isTop =
        details.parentElement &&
        details.parentElement.tagName &&
        details.parentElement.tagName.toUpperCase() === 'HEADER-MENU';
      if (isTop) {
        var rootList = document.querySelector(ROOT + ' .list-menu--inline');
        if (rootList) {
          rootList.querySelectorAll(':scope > li > header-menu > details[open]').forEach(function (d) {
            if (d !== details) d.open = false;
          });
        }
      } else {
        var parentUl = details.closest('ul');
        if (parentUl) {
          parentUl.querySelectorAll(':scope > li > details[open]').forEach(function (d) {
            if (d !== details) d.open = false;
          });
        }
      }
    }

    function openPanel() {
      clearClose();
      closeSiblings();
      details.open = true;
    }

    function scheduleClose() {
      clearClose();
      closeTimer = window.setTimeout(function () {
        details.open = false;
        closeTimer = null;
      }, HOVER_CLOSE_MS);
    }

    details.addEventListener('mouseenter', openPanel);
    details.addEventListener('mouseleave', scheduleClose);
    details.addEventListener('focusin', openPanel);
    details.addEventListener('focusout', function (e) {
      if (!details.contains(e.relatedTarget)) scheduleClose();
    });
  }

  function init(scope) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var root = scope && scope.querySelector ? scope.querySelector(ROOT) : document.querySelector(ROOT);
    if (!root) return;
    root.querySelectorAll('details').forEach(bindDetails);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('section-custom-menu-bar')) {
      init(e.target);
    }
  });
})();
